
























































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import HeadersTable from '@/components/Integrations/HeadersTable.vue';
import OutboundIntegrationLogDto from '@/models/Integrations/OutboundIntegrationLogDto';
import OutboundIntegrationLogListItemDto from '@/models/Integrations/OutboundIntegrationLogListItemDto';
import { OutboundIntegrationLogsModule } from '@/store/modules/outboundIntegrationLogs';

interface DataTableOptions {
    page: number;
    itemsPerPage: number;
    sortBy: string[];
    sortDesc: boolean[];
}

@Component({
    name: 'OutboundIntegrationLogList',
    components: { HeadersTable },
})
export default class extends GiganautVue {
    @Prop({ required: true }) integrationId!: string;

    dialog = false;
    detailTab = 0;
    tableOptions: DataTableOptions = {
        page: 1,
        itemsPerPage: 25,
        sortBy: ['requestTime'],
        sortDesc: [true],
    };

    headers = [
        { text: 'When', value: 'requestTime', width: 180 },
        { text: 'Verb', value: 'httpVerb', sortable: false, width: 70 },
        { text: 'URL', value: 'url', sortable: false },
        { text: 'Status', value: 'httpResponseCode', width: 90 },
        { text: 'Duration', value: 'durationMs', align: 'end', width: 100 },
    ];

    get loading(): boolean { return OutboundIntegrationLogsModule.loading; }
    get items(): OutboundIntegrationLogListItemDto[] { return OutboundIntegrationLogsModule.items; }
    get total(): number { return OutboundIntegrationLogsModule.total; }
    get selected(): OutboundIntegrationLogDto | null { return OutboundIntegrationLogsModule.selected; }
    get selectedLoading(): boolean { return OutboundIntegrationLogsModule.selectedLoading; }

    get hasRequestHeaders(): boolean {
        return !!this.selected && !!this.selected.requestHeaders && Object.keys(this.selected.requestHeaders).length > 0;
    }

    get hasResponseHeaders(): boolean {
        return !!this.selected && !!this.selected.responseHeaders && Object.keys(this.selected.responseHeaders).length > 0;
    }

    @Watch('integrationId', { immediate: true })
    onIntegrationIdChange(newVal: string) {
        if (!newVal) return;
        this.tableOptions = { page: 1, itemsPerPage: 25, sortBy: ['requestTime'], sortDesc: [true] };
        this.applyOptionsAndFetch();
    }

    @Watch('tableOptions', { deep: true })
    onOptionsChange() {
        if (!this.integrationId) return;
        this.applyOptionsAndFetch();
    }

    applyOptionsAndFetch() {
        const sortBy = (this.tableOptions.sortBy && this.tableOptions.sortBy[0]) || 'requestTime';
        const sortDesc = !!(this.tableOptions.sortDesc && this.tableOptions.sortDesc[0]);
        OutboundIntegrationLogsModule.setFiltersAndFetch({
            integrationId: this.integrationId,
            limit: this.tableOptions.itemsPerPage,
            offset: (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage,
            sortBy,
            sortOrder: sortDesc ? 'desc' : 'asc',
        });
    }

    reload() {
        this.applyOptionsAndFetch();
    }

    async openDialog(item: OutboundIntegrationLogListItemDto) {
        this.detailTab = 0;
        this.dialog = true;
        await OutboundIntegrationLogsModule.fetchById({ integrationId: this.integrationId, logId: item.id });
    }

    closeDialog() {
        this.dialog = false;
        OutboundIntegrationLogsModule.clearSelected();
    }

    statusColor(code: number): string {
        if (!code) return 'grey';
        if (code >= 200 && code < 300) return 'success';
        if (code >= 400 && code < 500) return 'warning';
        if (code >= 500) return 'error';
        return 'grey';
    }

    formatDate(s: string | null): string {
        if (!s) return '';
        const d = new Date(s);
        return isNaN(d.getTime()) ? '' : d.toLocaleString();
    }

    shortUrl(url: string): string {
        if (!url) return '';
        try {
            const u = new URL(url);
            return u.pathname + (u.search || '');
        } catch (_) {
            return url;
        }
    }

    prettyJson(raw: string): string {
        if (!raw) return '';
        try {
            return JSON.stringify(JSON.parse(raw), null, 2);
        } catch (_) {
            return raw;
        }
    }
}
